"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function Faq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const faqData = [{
    question: "How can I schedule my first appointment?",
    answer: "You can easily book online through our website or call our Limassol or Nicosia clinics directly. We offer flexible scheduling throughout the week to accommodate your busy lifestyle and ensure you get the care you need promptly."
  }, {
    question: "What can I expect during my initial consultation?",
    answer: "Your first visit involves a comprehensive assessment where we discuss your medical history and perform a physical examination. We then create a personalized treatment plan tailored to your specific health goals and physical condition."
  }, {
    question: "Do I need a referral from a GP to see a chiropractor?",
    answer: "No, a referral is not required to visit Bodywerks. As primary healthcare providers, we can assess and treat you directly. However, we are always happy to coordinate with your GP or other specialists if your condition requires an integrated approach."
  }, {
    question: "How many sessions will I need to see results?",
    answer: "Every patient is unique. While some feel immediate relief after one session, others may require a series of treatments for long-term correction. We will provide a clear timeline and progress markers during your initial evaluation."
  }];
  return <section data-section-id="16067" id="faq" className="bg-background py-16 md:py-24">
      <div ref={ref} className={cn("container max-w-3xl mx-auto px-4 transition-all duration-700 ease-in-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <h2 className="text-4xl md:text-5xl font-bold text-primary mb-12 text-center font-serif tracking-tight">
          Common Questions
        </h2>

        <Accordion type="single" collapsible className="w-full">
          {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border border-b last:border-b-0">
              <AccordionTrigger className="group [&>svg:last-child]:hidden hover:no-underline py-6 md:py-8">
                <span className="text-xl font-semibold text-primary font-sans text-left pr-4 tracking-tight">
                  {item.question}
                </span>
                <div className="shrink-0">
                  <Plus className="size-6 text-accent transition-transform duration-300 group-data-[state=open]:rotate-45" />
                </div>
              </AccordionTrigger>
              <AccordionContent className="text-lg text-muted-foreground font-sans pb-8 leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}